import { render } from "./DashboardQuotes.vue?vue&type=template&id=c3ef2d92&scoped=true"
import script from "./DashboardQuotes.vue?vue&type=script&lang=js"
export * from "./DashboardQuotes.vue?vue&type=script&lang=js"

import "./DashboardQuotes.vue?vue&type=style&index=0&id=c3ef2d92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3ef2d92"]])

export default __exports__